import { render, staticRenderFns } from "./FiBuOPList.vue?vue&type=template&id=5c20a87c&"
import script from "./FiBuOPList.vue?vue&type=script&lang=js&"
export * from "./FiBuOPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports